module.exports = __webpack_public_path__ + "static/media/Documentation.d6ea560b.svg";